import React, { Component, PropTypes } from 'react'
import { withRouter, browserHistory } from 'react-router'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import _ from 'lodash'
import Dropzone from 'react-dropzone'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem' // eslint-disable-line no-unused-vars
import RaisedButton from 'material-ui/RaisedButton'
import { cyan900 } from 'material-ui/styles/colors'
import { setItem, clearItemsErrors, authInfo } from '../actions'
import { uploadImage } from '../lib/upload'
import Alert from '../components/home/Alert'
import EditorData from '../components/items/Common/EditorData'
import PrintData from '../components/items/Common/PrintData'
import ItemInfo from '../components/items/Common/ItemInfo'
import PreviewData from '../components/items/Common/PreviewData'
import ShippingData from '../components/items/Common/ShippingData'

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  item: PropTypes.object,
  error: PropTypes.any,
  products: PropTypes.any,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)
class ItemNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        sku: null,
      },
      item: {
        id: 0,
        productId: null,
        sku: '',
        name: '',
        foldername: '',
        msrp: 0,
        disabled: false,
        outOfStock: false,
        maskHorizontal: '',
        maskVertical: '',
        shippingData:{
          height: 0,
          width: 0,
          length: 0,
          weight: 0,
        },
        printData: {
          printMinPpi: 0,
          portrait: [{
            width: 0,
            height: 0,
            rotate: 0,
            sku: '',
            index: 1,
            pdfIndex: 1,
            x: 0,
            y: 0,
            bleed: false,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
          landscape: [{
            width: 0,
            height: 0,
            rotate: 0,
            sku: '',
            index: 1,
            pdfIndex: 1,
            x: 0,
            y: 0,
            bleed: false,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
        },
        preview: {
          portrait: [{
            img: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            angle: 0,
            index: 1,
            z: 0,
            zoomedOverlay: '',
            zoomedX: 0,
            zoomedY: 0,
            zoomedWidth: 0,
            zoomedHeight: 0,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
          landscape: [{
            img: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            angle: 0,
            index: 1,
            z: 0,
            zoomedOverlay: '',
            zoomedX: 0,
            zoomedY: 0,
            zoomedWidth: 0,
            zoomedHeight: 0,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
          numPhotos: 1,
        },
        editor: {
          border: 0,
          orientation: 'portrait',
          width: 0,
          height: 0,
          bandHeight: 0,
          textSize: 0,
        },
      },
      open: false,
      edited: false,
      useNewPreview: false,
      selectedPreview:{},
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    // console.log("nextProps:", nextProps)
    // let item;
    // if (nextProps.item.id) {
    //   item = nextProps.item;
    // } else {
    //   item = nextProps.item[0];
    // }
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.item && !nextProps.error) {
      this.setState({
        // item,
        alertOpen: true,
        error: false,
        alertMessage: 'Product Item saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const item = this.state.item;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = item[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleProductChange(event, index, value) {
    const nextState = this.state.item;
    nextState.productId = value;
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleOrientationChange(event, index, value) {
    const nextState = this.state.item;
    nextState.editor.orientation = value;
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }

  handleSubmit() {
    this.props.dispatch(clearItemsErrors());
    const pItem = this.state.item;
    // console.log("IMG:", this.state.item, pItem)
    pItem.img = (pItem.img === null) ? '' : pItem.img;
    this.props.dispatch(setItem(pItem));
  }
  handleCancel() {
    this.props.dispatch(clearItemsErrors());
    browserHistory.push('/items?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/items?page=1');
    }
  }
  onDrop(file, bucket, name, handleChangeOption) {
    console.log('FILE', file)
    const { dispatch } = this.props
    console.log('# New file for bucket: ', bucket);
    console.log('# dispatching uploadImage...');
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        console.log('response***', response)
        handleChangeOption({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        //alert(`Image upload failed: ${err}`);
        return '';
      });
  }
  onDropImage(file, bucket, name) {
    console.log('FILE', file)
    const { dispatch } = this.props
    console.log('# New file for bucket: ', bucket);
    console.log('# dispatching uploadImage...');
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        console.log('response***',response)
        this.handleChange({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        //alert(`Image upload failed: ${err}`);
        return '';
      });
  }
  handleChange(e) {
    const nextState = this.state.item;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleUploadedImage(name, value) {
    const nextState = this.state.item;
    _.set(nextState, name, value)
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChangePreview(e) {
    console.log('Preview Data is changed', e.target.name, e.target.value)
    const nextState = this.state.item.preview;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      preview: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChangePrintdata(e) {
    const nextState = this.state.item.printData;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      printData: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  ChangePreviewImages(name, value) {
    const nextState = this.state.item.preview;
      _.set(nextState, name, value);
    this.setState({
      preview: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChangeShipping(e) {
    const nextState = this.state.item.shippingData;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, Number(e.target.value));
    }
    this.setState({
      shippingData: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleNumPhotos(e) {
    const { item } = this.state
    item.preview.numPhotos = e.target.value
    this.setState({
      item,
      edited: true
    })
    this.setRequiredParams()
    this.addFieldsBasedOnNumPhotos(e.target.value)
  }
  addFieldsBasedOnNumPhotos(value) {
    var printDataArray = this.state.item.printData
    var previewArray = this.state.item.preview
    if (printDataArray.portrait.length < value) {
      for (var i = printDataArray.portrait.length; i < value; i++) {
        printDataArray.portrait.push({
          bleed: false,
          height:0,
          index: i + 1,
          pdfIndex: i + 1,
          rotate: 0,
          sku: '',
          width: 0,
        })
      }
      for (var i = previewArray.portrait.length; i < value; i++) {
        previewArray.portrait.push({
          angle: 0,
          height: 0,
          img: '',
          index: i + 1,
          width:0,
          x: 0,
          y: 0,
          z: 0,
          zoomedHeight: 0,
          zoomedOverlay: '',
          zoomedWidth: 0,
          zoomedX: 0,
          zoomedY: 0,
        })
      }
    }
  }
  handleItemOptionSelect(event, index, value){
    console.log('Value in Select', value)
    this.setState({
      useNewPreview: true,
      selectedPreview: value.preview,
    })
  }
  render() {
    const productSelect = _.map(this.props.products, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    const { printData } = this.state.item;
    const itemPreview = this.state.useNewPreview ? this.state.selectedPreview : this.props.item.preview
    // console.log("this.state.item**** ", printData)
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="items component" style={authPage}>
        <h2>New Item</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <TextField
            value={this.state.item.preview.numPhotos}
            onChange={this.handleNumPhotos}
            floatingLabelText="Number of Photos"
            name="numPhotos"
            floatingLabelStyle={styles.floatingLabelStyle}
          />
          <ItemInfo
            styles={styles}
            item={this.state.item}
            handleChange={this.handleChange}
            handleProductChange={this.handleProductChange}
            handleUploadedImage={this.handleUploadedImage}
            products={this.props.products}
            onDropImage={this.onDropImage}
            required={this.state.required}
            dropzoneStyles={dropzoneStyles}
            client={client}
          />
          <br />
          <TextField
            floatingLabelText="Mask"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={this.state.item.maskVertical || ''}
            name="item.maskVertical"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <Dropzone
            ref="dropzone"
            accept="image/jpeg, image/png, image/gif"
            style={dropzoneStyles}
            onDrop={(file) => this.onDrop(file, 'focus-product-images', "maskVertical", this.handleChange)}
          >Upload Mask</Dropzone>
          <br />
          <TextField
            floatingLabelText="Overlay"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={this.state.item.maskHorizontal || ''}
            name="item.maskHorizontal"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <Dropzone
            ref="dropzone"
            accept="image/jpeg, image/png, image/gif"
            style={dropzoneStyles}
            onDrop={(file) => this.onDrop(file, 'focus-product-images', "maskHorizontal", this.handleChange)}
          >Upload Overlay</Dropzone>
          <br />
          <TextField
            floatingLabelText="Social Image"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={this.state.item.socialImage || ''}
            name="item.socialImage"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES socialImage', res);
                  const targetName = 'socialImage'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Social</p>
          </button>
          <br />
        </div>
        <ShippingData 
          styles={styles}
          item={this.state.item}
          disableFields={this.props.navigationType}
          handleChangeShipping={this.handleChangeShipping}
        />
        <PrintData
          styles={styles}
          item={this.state.item}
          handleChange={this.handleChange}
          handleChangePrintdata={this.handleChangePrintdata}
          printData={this.state.item.printData}
          dropzoneStyles={dropzoneStyles}
          onDrop={this.onDrop}
          disableFields={this.props.navigationType}
          numPhotos={this.state.item.preview.numPhotos}
        />
        <PreviewData
          styles={styles}
          item={this.state.item}
          handleChange={this.handleChangePreview}
          ChangePreviewImages={this.ChangePreviewImages}
          dropzoneStyles={dropzoneStyles}
          onDrop={this.onDrop}
          client={client}
          items={this.props.items}
          handleItemOptionSelect={this.handleItemOptionSelect}
          itemPreview={itemPreview}
        />
        <EditorData
          item={this.state.item}
          styles={styles}
          handleChange={this.handleChange}
          handleOrientationChange={this.handleOrientationChange}
        />
      </div>
    )
  }
}

ItemNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
}

ItemNewPage.propTypes = propTypes

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    item: state.items.item,
    items: state.items,
    error: state.items.error,
    products: state.products.results,
  }
}

export default withRouter(connect(mapStateToProps)(ItemNewPage));


// WEBPACK FOOTER //
// ./src/containers/ItemNewPage.js